import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import styled from 'styled-components';

import { ExternalLink } from 'core/routing';
import { Tooltip } from 'components';
import { clientStore } from 'apps/client/app';

import { Name } from 'apps/repository/views/columns/name';
import { Message } from 'apps/repository/views/columns/message';
import { LastModified } from 'apps/repository/views/columns/lastModified';
import { IconColumn } from 'apps/repository/styles';

export const ColumnTitles = withNamespaces()(
  observer(({ t, isFile, sizeStr, formatObj }) => {
    if (isFile) {
      let link = '';
      if (formatObj) {
        let { name } = formatObj;
        if (formatObj.formatLabel) {
          name = `${formatObj.name} (${formatObj.formatLabel})`;
        }
        link = <span>{name}</span>;
        if (formatObj.formatLink) {
          link = (
            <ExternalLink to={formatObj.formatLink}>
              <Tooltip />
              <span data-tip='Learn more about this file format'>{name}</span>
            </ExternalLink>
          );
        }
      }
      return (
        <Main centered>
          {link ? (
            <FileSize>
              {link}
              {` - ${sizeStr}`}
            </FileSize>
          ) : (
            <FileSize>{sizeStr}</FileSize>
          )}
        </Main>
      );
    }
    let lastModifiedText = 'Last Modified / Actions';
    if (['s', 'xs'].includes(clientStore.activeBreakPoint)) {
      lastModifiedText = 'Last Modified';
    }
    return (
      <Main>
        <IconColumn slim />
        <Name isTitle isFlex />
        <Message message={t('Last Contribution')} isTitle />
        <LastModified title={t(lastModifiedText)} display isTitle />
      </Main>
    );
  }),
);

const Main = styled.div`
  width: 100%;
  height: 34px;
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  padding-right: 20px;
  ${props =>
    props.centered
      ? 'line-height: 34px; text-align: center; padding-right: 0'
      : ''};
`;

const FileSize = styled.span`
  font-size: 0.775em;
  color: ${props => props.theme.color.wfGrey};
  > a {
    color: ${props => props.theme.color.primary};
  }
`;
